import styled from 'styled-components';
import { ReactComponent as NameLogo } from './NameLogo.svg';
import { ReactComponent as ShortLogo } from './ShortLogo.svg';

export const StyledBlackLogo = styled.div`
    display: flex;
    svg {
        height: 4.8rem;
        width: 23.2rem;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        svg {
            height: 3.2rem;
            width: 15.4rem;
        }
    }
`;

export const NameLogoStyled = styled(NameLogo)`
    @media (max-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        width: 11.4rem;
        height: auto;
    }
`;
export const ShortLogoStyled = styled(ShortLogo)`
    @media (max-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        width: 3.2rem;
        height: 3.2rem;
    }
`;
